import { ArrowRight, FileText, Smartphone, StickyNote } from "lucide-react";
import { Lemon, Herb, Tomato } from "./FoodMotifs";

/**
 * Pure-CSS/SVG illustration: messy recipe sources → clean recipe card.
 * Uses semantic tokens so it inherits the warm cookbook palette.
 */
export const HeroVisual = () => {
  return (
    <div className="relative mx-auto w-full max-w-md select-none">
      {/* Floating food motifs — decorative, hidden from a11y tree. */}
      <Lemon className="absolute -left-2 -top-4 h-10 w-10 rotate-12 text-mustard/70" />
      <Herb className="absolute -right-2 top-8 h-12 w-12 -rotate-12 text-basil/70" />
      <Tomato className="absolute -bottom-4 right-10 h-9 w-9 text-tomato/70" />
      <div className="grid grid-cols-[1fr_auto_1.2fr] items-center gap-3 sm:gap-5">
        {/* Messy stack */}
        <div className="relative h-56 sm:h-64">
          {/* Paper scrap */}
          <div className="absolute left-2 top-4 w-32 -rotate-6 rounded-md bg-card p-3 shadow-card ring-1 ring-border">
            <FileText className="mb-1 h-3 w-3 text-muted-foreground" />
            <div className="space-y-1">
              <div className="h-1.5 w-3/4 rounded bg-muted" />
              <div className="h-1.5 w-1/2 rounded bg-muted" />
              <div className="h-1.5 w-2/3 rounded bg-muted" />
              <div className="h-1.5 w-1/3 rounded bg-muted" />
            </div>
          </div>
          {/* Phone screenshot */}
          <div className="absolute right-1 top-0 w-24 rotate-6 rounded-xl bg-foreground/90 p-1 shadow-lift">
            <div className="rounded-lg bg-card p-2">
              <Smartphone className="mb-1 h-3 w-3 text-muted-foreground" />
              <div className="space-y-1">
                <div className="h-1.5 w-full rounded bg-muted" />
                <div className="h-1.5 w-4/5 rounded bg-muted" />
                <div className="h-1.5 w-2/3 rounded bg-muted" />
                <div className="h-1.5 w-3/5 rounded bg-muted" />
                <div className="h-1.5 w-4/5 rounded bg-muted" />
              </div>
            </div>
          </div>
          {/* Sticky note */}
          <div className="absolute bottom-2 left-8 w-24 rotate-3 rounded-sm bg-secondary/30 p-2 shadow-soft ring-1 ring-secondary/20">
            <StickyNote className="mb-1 h-3 w-3 text-secondary" />
            <div className="space-y-1">
              <div className="h-1.5 w-3/4 rounded bg-secondary/40" />
              <div className="h-1.5 w-1/2 rounded bg-secondary/40" />
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
          <ArrowRight className="h-5 w-5" />
        </div>

        {/* Clean recipe card */}
        <div className="rounded-xl bg-card p-4 shadow-card ring-1 ring-border">
          <div className="mb-2 h-2 w-3/4 rounded bg-foreground/80" />
          <div className="mb-3 flex gap-1">
            <div className="h-1.5 w-8 rounded-full bg-primary/30" />
            <div className="h-1.5 w-6 rounded-full bg-secondary/40" />
          </div>
          <div className="space-y-1.5">
            <div className="flex items-center gap-1.5">
              <div className="h-1 w-1 rounded-full bg-primary" />
              <div className="h-1.5 w-full rounded bg-muted" />
            </div>
            <div className="flex items-center gap-1.5">
              <div className="h-1 w-1 rounded-full bg-primary" />
              <div className="h-1.5 w-5/6 rounded bg-muted" />
            </div>
            <div className="flex items-center gap-1.5">
              <div className="h-1 w-1 rounded-full bg-primary" />
              <div className="h-1.5 w-4/6 rounded bg-muted" />
            </div>
            <div className="flex items-center gap-1.5">
              <div className="h-1 w-1 rounded-full bg-primary" />
              <div className="h-1.5 w-5/6 rounded bg-muted" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
